import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CheckboxInput,
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import {
  CheckBoxInputContainer,
  HoverActionButtonContainer,
  StyledQuestionnaireListItem,
  IconContainer,
} from './questionnaire-list-item.styles';

import { IEmployeeQuestionnaireSettingsListItemProps } from '../../../../employee-questionnaire-settings-interfaces';

const QuestionnaireListItem = ({
  checked,
  onChange,
  item,
  buttonPosition,
  handleMoveTo,
  index,
  draggable,
  onDragStart,
  onDragEnd,
  onDragOver,
}: IEmployeeQuestionnaireSettingsListItemProps) => {
  const { t } = useTranslation();
  const [isShown, setIsShown] = useState(false);

  return (
    <StyledQuestionnaireListItem
      onMouseOver={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
      {...(draggable && { draggable })}
      {...(onDragStart && { onDragStart: onDragStart(index) })}
      {...(onDragStart && { onDragEnd })}
      {...(onDragOver && { onDragOver: onDragOver(index) })}
    >
      <CheckBoxInputContainer>
        {draggable && (
          <IconContainer>
            <svg
              width="16px"
              height="16px"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.5 8C10.3284 8 11 7.32843 11 6.5C11 5.67157 10.3284 5 9.5 5C8.67157 5 8 5.67157 8 6.5C8 7.32843 8.67157 8 9.5 8ZM9.5 14C10.3284 14 11 13.3284 11 12.5C11 11.6716 10.3284 11 9.5 11C8.67157 11 8 11.6716 8 12.5C8 13.3284 8.67157 14 9.5 14ZM11 18.5C11 19.3284 10.3284 20 9.5 20C8.67157 20 8 19.3284 8 18.5C8 17.6716 8.67157 17 9.5 17C10.3284 17 11 17.6716 11 18.5ZM15.5 8C16.3284 8 17 7.32843 17 6.5C17 5.67157 16.3284 5 15.5 5C14.6716 5 14 5.67157 14 6.5C14 7.32843 14.6716 8 15.5 8ZM17 12.5C17 13.3284 16.3284 14 15.5 14C14.6716 14 14 13.3284 14 12.5C14 11.6716 14.6716 11 15.5 11C16.3284 11 17 11.6716 17 12.5ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z"
                fill="#121923"
              />
            </svg>
          </IconContainer>
        )}
        <CheckboxInput type="checkbox" checked={checked} onChange={onChange} />
        <Typography>{t(`settings:employeeQuestionnaire.questionnaireInfo.${item}`)}</Typography>
      </CheckBoxInputContainer>
      {isShown && (
        <HoverActionButtonContainer>
          <Typography className={'hover-action-button'} onClick={handleMoveTo}>
            {buttonPosition === 'right' && (
              <Icon
                rightMargin={false}
                icon={ICONS.chevronLeft}
                size={16}
                color={PLATFORM_THEME_COLORS.primary.blue}
              />
            )}
            {t('settings:employeeQuestionnaire.buttons.moveTo')}
            {buttonPosition === 'left' && (
              <Icon
                icon={ICONS.chevronRight}
                size={16}
                rightMargin={false}
                color={PLATFORM_THEME_COLORS.primary.blue}
              />
            )}
          </Typography>
        </HoverActionButtonContainer>
      )}
    </StyledQuestionnaireListItem>
  );
};

export default QuestionnaireListItem;
